<template>
  <div class="row">
    <div class="col-12 col-md-4 col-lg-6 col-xl-8">
      <h5 class="text-orange">
        <span class="mr-2">
          {{ codigo }}
        </span>
        -
        <span class="ml-2">
          {{ titulo }}
        </span>
      </h5>
    </div>
    <div class="col-12 col-md-8 col-lg-6 col-xl-4">
      <b-button-group size="sm" class="ml-2" style="float: right">
        <b-dropdown variant="info" right>
          <template #button-content>
            <i class="fas fa-file-archive mr-2"></i>
            Comprovantes despesas
          </template>

          <b-dropdown-item @click="baixarComprovantes(false)"
            >Somente custos próprios</b-dropdown-item
          >
          <b-dropdown-item v-if="!ehExecutora" @click="baixarComprovantes(true)"
            >Incluir comprovantes da executora</b-dropdown-item
          >
        </b-dropdown>
      </b-button-group>
      <b-button-group
        size="sm"
        class="ml-2"
        v-if="!ehExecutora"
        style="float: right"
      >
        <b-dropdown variant="info" right>
          <template #button-content>
            <i class="fas fa-file-pdf mr-2"></i>
            Relatório
          </template>

          <b-dropdown-item @click="baixarPDF(false)"
            >Individual
          </b-dropdown-item>
          <b-dropdown-item @click="baixarPDF(true)"
            >Consolidado (Todas empresas)</b-dropdown-item
          >
        </b-dropdown>
      </b-button-group>

      <b-button
        @click="baixarPDF(false)"
        variant="info"
        class="ml-2"
        v-if="ehExecutora"
        style="float: right"
      >
        <i class="fas fa-file-pdf mr-2"></i>
        Relatório
      </b-button>

      <b-button-group
        size="sm"
        class="ml-2"
        v-if="!ehExecutora"
        style="float: right"
      >
        <b-dropdown variant="info" right>
          <template #button-content>
            <i class="fas fa-file-excel mr-2"></i>
            Anexo 5
          </template>

          <b-dropdown-item @click="baixarExcel(false)"
            >Individual
          </b-dropdown-item>
          <b-dropdown-item @click="baixarExcel(true)"
            >Consolidado (Todas empresas)</b-dropdown-item
          >
        </b-dropdown>
      </b-button-group>

      <b-button
        @click="baixarExcel(false)"
        variant="info"
        class="ml-2"
        v-if="ehExecutora"
        style="float: right"
      >
        <i class="fas fa-file-excel mr-2"></i>
        Anexo 5
      </b-button>
    </div>
    <div class="col-12 d-flex mt-1">
      <h6 class="text-white bg-secondary px-1 py-1 border rounded-lg">
        <span class="">
          {{ apelido }}
        </span>
      </h6>
    </div>
    <div class="col-12 d-flex" v-if="projetoObj != null">
      <div>
        <b-badge class="mr-2" variant="info" v-if="projetoObj.statusProponente">
          {{
            retornarStatus(
              projetoObj.proposta.aprovada
                ? projetoObj.statusProponente
                : projetoObj.proposta.statusProponente
            )
          }}
        </b-badge>

        <b-badge variant="success" class="mr-2">
          Data de início: {{ projetoObj.dataInicial }}
        </b-badge>

        <b-badge variant="success" class="mr-2">
          Data de conclusão: {{ projetoObj.dataTermino }}
        </b-badge>

        <b-badge variant="success" class="mr-2">
          Mês de Execução: {{ calcularMesExecucao(projetoObj) }}
        </b-badge>

        <b-badge variant="success" class="mr-2">
          TRL: {{ calcularTRL(projetoObj) }}
        </b-badge>
      </div>
    </div>
    
    <accordion
      v-for="accordion in gerarTelas()"
      :key="accordion.tela"
      class="col-12 mt-3"
      :hideTitle="accordion.esconderTitulo && !id"
      :disabled="
        accordion.tela != 'aneel' && accordion.tela != 'documentos'
          ? !liberarAccordions
          : false
      "
      :id="accordion.tela"
      :title="accordion.titulo"
      @abriu="abriu(accordion.tela)"
    >
      <componentes
        :tela="accordion.tela"
        :projeto-id="id"
        :projeto-id-base="projetoIdBase"
        :nome-id-projeto="config.nomeIdProjeto"
        :endpoint-proposta="config.endpointProposta"
        :proposta-id-base="propostaIdBase"
        :endpoint="config.endpoint"
        :projeto="projetoObj"
        :ref="accordion.tela"
        :projeto-editavel="projetoEditavel"
        :chave-permissao="accordion.chavePermissao"
        @update="buscarProjeto"
        @retornarAbas="verificarAneel"
      />
    </accordion>
  </div>
</template>
<script>
import Accordion from "@/components/card/Accordion";
import Componentes from "./Componentes";
import ComponentesConfig from "./componentes.config";

import { START_LOADING, STOP_LOADING } from "@/store/Store";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";

import ProjetoService from "@/common/services/projeto/projeto.service";

import helpers from "@/common/utils/helpers";
import { Excel } from "@/common/utils/excel";
import moment from "moment";

export default {
  name: "ProjetoForm",
  mixins: [AlertasMixin],
  props: {
    id: {
      required: true,
    },
    tipoProjeto: {
      default: "Proponente",
    },
    texto: {
      default: "Projeto",
    },
    rota: {
      default: "projeto",
    },
  },
  components: {
    Accordion,
    Componentes,
  },
  data: () => ({
    projeto: null,
    projetoIdBase: null,
    propostaIdBase: null,
    liberarAccordions: false,
  }),
  methods: {
    calcularMesExecucao(projeto) {
      if (!projeto.dataInicial) return "";
      let dataInicial = moment(projeto.dataInicial, "DD/MM/YYYY");
      let dataAtual = moment();
      var duracao = moment.duration(dataAtual.diff(dataInicial));
      let meses = parseInt(duracao.asMonths()) + 1;
      return `Mês ${meses}`;
    },
    calcularTRL(projeto) {
      const trl =
        projeto?.trl?.trlFinal ??
        projeto?.trl?.trlExecucao ??
        projeto?.trl?.trlProposta ??
        projeto?.proposta?.descricaoTecnica?.trl;
      return trl ? trl : "Não informado";
    },
    verificarAneel: function (abas) {
      if (
        abas.find((el) => el.xml == "comprovante-xml-inicio").objeto.length > 0
      ) {
        this.liberarAccordions = true;
      }
    },
    baixarComprovantes: function (incluirComprovantesPagadora) {
      ProjetoService.baixarComprovantes(this.id, incluirComprovantesPagadora)
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/zip" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `comprovantes.zip`;
          link.click();
        })
        .catch((err) => {
          if (err.response.status == 400) {
            const blob = new Blob([err.response.data], {
              type: "application/json",
            });
            const fr = new FileReader();
            fr.onload = (e) => {
              this.alertaErro(JSON.parse(e.target.result).errors);
            };
            fr.readAsText(blob);
          } else this.alertaErro("Erro ao baixar");
        });
    },
    baixarPDF: function (consolidado) {
      this.$store.dispatch(START_LOADING);
      ProjetoService.relatorioConsolidadoPDF(this.id, consolidado)
        .then((res) => {
          this.$store.dispatch(STOP_LOADING);
          const blob = new Blob([res.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `Relatório ${
            consolidado ? "Consolidado" : this.empresasSelecionada.nomeFantasia
          }.pdf`;
          link.click();
        })
        .catch((err) => {
          if (err.response.status == 400) {
            const blob = new Blob([err.response.data], {
              type: "application/json",
            });
            const fr = new FileReader();
            fr.onload = (e) => {
              this.alertaErro(JSON.parse(e.target.result).errors);
            };
            fr.readAsText(blob);
          } else this.alertaErro("Erro ao baixar");
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    baixarExcel: function (consolidado = false) {
      this.$store.dispatch(START_LOADING);
      ProjetoService.baixarAnexo5(this.id, consolidado)
        .then((res) => {
          let xmlString = res.data.data;
          let doc = new DOMParser().parseFromString(xmlString, "text/html");
          const ex = new Excel();

          for (let sheet of doc.getElementsByClassName("sheet")) {
            ex.adicionarSheet(sheet, sheet.getAttribute("nome-sheet"));
          }
          ex.baixarExcel("Anexo5.xlsx");
        })
        .catch(() => {
          this.alertaErro("Erro ao gerar excel!");
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    retornarStatus: function (status) {
      if (!status) return "";
      return helpers.getEnum(status).text;
    },
    abriu: function (tela) {
      /* eslint-disable */
      try {
        this.$refs[tela][0].montar(tela);
      } catch (e) {}
    },
    gerarTelas: function () {
      if (!this.projeto) return [];
      return this.config.componentes.filter((el) => {
        return this.permissao(el.chavePermissao).r;
      });
    },
    buscarProjeto: function () {
      ProjetoService.buscarProjeto(this.id).then((response) => {
        this.projeto = response.data.data;

        if (!this.ehProponente) {
          this.projetoIdBase = response.data.data.projeto.id;
          this.propostaIdBase = response.data.data.projeto.proposta.id;
        } else {
          this.propostaIdBase = response.data.data.proposta.id;
          this.projetoIdBase = response.data.data.id;
        }
      });
    },
  },
  mounted() {
    this.$store.dispatch(DEFINIR_BREADCRUMB, [
      {
        titulo: this.ehAdmin ? "Projetos P&D" : this.texto,
        to: { name: this.ehAdmin ? "projeto-todos-lista" : this.rota },
      },
      { titulo: "Detalhes" },
    ]);

    ProjetoService.setEndpoint(ComponentesConfig[this.tipoProjeto].endpoint);

    if (this.id) {
      this.buscarProjeto();
    }
  },
  computed: {
    permissao() {
      return this.$store.getters["app/retornaPermissao"];
    },
    ehAdmin() {
      return this.$store.getters["app/ehAdmin"];
    },
    empresasSelecionada() {
      return this.$store.state.app.selectedCompanyObj;
    },
    config: function () {
      return ComponentesConfig[this.tipoProjeto];
    },
    codigo: function () {
      if (!this.projetoObj) return "";
      return this.projetoObj.codigo;
    },
    titulo: function () {
      if (!this.projetoObj) return "";
      return this.projetoObj.proposta.descricaoTecnica.titulo;
    },
    apelido: function () {
      if (!this.projetoObj) return "";
      return this.projetoObj.proposta.descricaoTecnica.apelido;
    },
    ehProponente: function () {
      return this.$route.name == "projeto-detalhamento";
    },
    ehExecutora: function () {
      return (
        this.$route.name == "projeto-detalhamento-executora-criadora" ||
        this.$route.name == "projeto-detalhamento-executora-associada"
      );
    },
    projetoObj: function () {
      if (!this.projeto) return null;
      if (this.ehProponente) {
        if (this.projeto.dataInicio) {
          this.projeto.dataTermino = helpers.formatarDataBr(
            helpers.adicionarValorData(
              this.projeto.dataInicio,
              this.projeto.duracao,
              "M"
            )
          );

          this.projeto.dataInicial = helpers.formatarDataBr(
            this.projeto.dataInicio
          );
        }
        return this.projeto;
      } else {
        if (this.projeto.projeto.dataInicio) {
          this.projeto.projeto.dataTermino = helpers.formatarDataBr(
            helpers.adicionarValorData(
              this.projeto.projeto.dataInicio,
              this.projeto.projeto.duracao,
              "M"
            )
          );

          this.projeto.projeto.dataInicial = helpers.formatarDataBr(
            this.projeto.projeto.dataInicio
          );
        }
        return this.projeto.projeto;
      }
    },
    projetoEditavel() {
      if (this.ehAdmin) return true;
      return !this.projetoObj.projetoFinalizado;
    },
  },
};
</script>
<style>
.title {
  padding-left: 10px;
}

.title::before {
  content: "\f067";
  font-family: "Font Awesome 5 Free" !important;
  font-weight: 600;
  -webkit-transition: -webkit-transform 0.25s;
  transition: -webkit-transform 0.25s;
  transition: transform 0.25s;
  transition: transform 0.25s, -webkit-transform 0.25s;
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  color: #44a2d2;
  position: absolute;
  left: 10px;
}
.collapsed > .title::before {
  content: "\f067";
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
}
.not-collapsed > .title::before {
  content: "\f068";
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}
</style>
